import api from '../baseApi.js'
import { unwrap } from '../helpers.js'

export const calendarApi = {
  getEvents: (params) => api.get('/calendar/events', { params }).then(unwrap),
  createEvent: (data) => api.post('/calendar/events', data).then(unwrap),
  updateEvent: (id, data) => api.put(`/calendar/events/${id}`, data).then(unwrap),
  removeEvent: (id) => api.delete(`/calendar/events/${id}`).then(unwrap),
}
